import { useEffect } from "react";
import { clientPost } from "@/service/client-api/client-api";

export function useStepInitialization(step: RoadmapStepVM) {
  useEffect(() => {
    if (!step.progress) {
      clientPost("roadmap.step.start", { id: step.id });
    }
  }, [step.id, step.progress]);
}
